import { render, staticRenderFns } from "./foldable.vue?vue&type=template&id=585ca8ec"
import script from "./foldable.vue?vue&type=script&lang=js"
export * from "./foldable.vue?vue&type=script&lang=js"
import style0 from "./foldable.vue?vue&type=style&index=0&id=585ca8ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports